

























































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IImportSource, IImportSourceCredentials } from "@/models/imports";
import { DataModules } from "@/store/modules/data";
import { ImportTaxSettingTypes } from "@/data/enums/imports";
import { mapState } from "vuex";
import { IState } from "@/store";

interface ISourceCredentialForm {
  url: string;
  username: string;
  password?: string;
  tax_setting: IImportSourceCredentials["tax_setting"];
  admin_dashboard_url: IImportSourceCredentials["admin_dashboard_url"];
}

@Component({
  computed: {
    ...mapState({
      systemIPAddresses: (state: IState) => state.constants.systemIPAddresses
    })
  }
})
export default class AddEditSourceCredentialsModal extends Mixins(
  HasValidation
) {
  // Props

  @Prop({ required: true })
  public source!: IImportSource;

  @Prop({ required: true })
  public sourceId!: IImportSource["id"];

  @Prop({ required: false, default: null })
  public credentialsId!: IImportSourceCredentials["id"];

  @Prop({ required: false, default: "" })
  public url!: IImportSourceCredentials["url"];

  @Prop({ required: false, default: "" })
  public username!: IImportSourceCredentials["username"];

  @Prop({ required: false, default: ImportTaxSettingTypes.INHERIT })
  public tax_setting!: IImportSourceCredentials["tax_setting"];

  @Prop({ required: false, default: "" })
  public admin_dashboard_url!: IImportSourceCredentials["admin_dashboard_url"];

  // Data

  public isProcessing = false;
  public systemIPAddresses!: string[];
  public form: ISourceCredentialForm = {
    admin_dashboard_url: this.admin_dashboard_url,
    password: undefined,
    tax_setting: this.tax_setting,
    url: this.url,
    username: this.username
  };

  public get taxSettingOptions() {
    return [
      {
        label: this.$t("_sentence.imports.import_tax_setting_inherit", {
          source: this.source.name
        }),
        value: ImportTaxSettingTypes.INHERIT
      },
      {
        label: this.$t("_sentence.imports.import_tax_setting_inclusive"),
        value: ImportTaxSettingTypes.INCLUSIVE
      },
      {
        label: this.$t("_sentence.imports.import_tax_setting_exclusive"),
        value: ImportTaxSettingTypes.EXCLUSIVE
      }
    ];
  }

  // Life-cycle methods

  public created() {
    this.$store.dispatch("constants/getSystemIPAddresses");
  }

  // Methods

  public async saveCredentials() {
    try {
      this.isProcessing = true;
      // Validate form
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Save credentials
      this.credentialsId
        ? await this.updateCredentials()
        : await this.addCredentials();
      // Confirmation toast
      this.$buefy.toast.open({
        message: this.$t("_sentence.imports.source_credentials_saved", {
          source: this.source.name
        }) as string
      });
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.isProcessing = false;
      if (this.$store.getters["api/is"](error, 422))
        this.$store.dispatch("api/handleValidationError", { error, vm: this });
      else this.$store.dispatch("api/handleErrorSnackbar", error);
    }
  }

  public updateCredentials(): Promise<IImportSourceCredentials> {
    return this.$store.dispatch(
      `data/${DataModules.IMPORTS}/updateSourceCredentials`,
      {
        sourceId: this.sourceId,
        credentialsId: this.credentialsId,
        payload: {
          data: this.form
        }
      }
    );
  }

  public addCredentials(): Promise<IImportSourceCredentials> {
    return this.$store.dispatch(
      `data/${DataModules.IMPORTS}/addSourceCredentials`,
      {
        sourceId: this.sourceId,
        payload: {
          data: this.form
        }
      }
    );
  }
}
